import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { useRegion } from "../context/RegionContext";
import { CHAT_DICT } from "./chat";

// Add a language = add its dictionary here and list it in the region config (backend/regions.py).
export const LANGUAGE_NAMES = { es: "Español", en: "English", ca: "Català", de: "Deutsch", fr: "Français", it: "Italiano" };

const DICT = {
  es: {
    "brand.tagline": "Encuentra alojamiento, conoce gente, descubre lugares, servicios, trabajo y mucho más.",
    "brand.tagline2": "Siempre gratis y sin comisiones.",
    "zone.all": "Toda la isla",
    "zone.allRegion": "Toda {region}",
    "seo.title": "Mercat Menorca",
    "search.placeholder": "Buscar en {region}...",
    "search.submit": "Buscar",
    "home.categories": "Categorías",
    "home.footer": "Hecho en {region}, para {region}. Sin comisiones.",
    "home.swipeHint": "Desliza para ver el Mercat",
    "nav.home": "Inicio",
    "nav.mercat": "Mercat",
    "nav.profile": "Perfil",
    "nav.prev": "Pantalla anterior",
    "nav.next": "Pantalla siguiente",
    "mercat.title": "Mercat",
    "mercat.results": "{n} anuncios",
    "mercat.result1": "1 anuncio",
    "mercat.price": "Precio",
    "mercat.loadMore": "Cargar más",
    "mercat.end": "Has llegado al final",
    "mercat.filters": "Filtros",
    "sort.newest": "Más recientes",
    "sort.price_asc": "Precio: menor a mayor",
    "sort.price_desc": "Precio: mayor a menor",
    "filters.keyword": "Palabra clave",
    "filters.keywordPh": "Ej: bicicleta, piso, kayak...",
    "filters.category": "Categoría",
    "filters.allCategories": "Todas las categorías",
    "filters.zone": "Zona",
    "filters.priceMin": "Precio mín. (€)",
    "filters.priceMax": "Precio máx. (€)",
    "filters.sort": "Ordenar por",
    "filters.clear": "Limpiar",
    "filters.apply": "Ver resultados",
    "card.details": "Ver detalles",
    "price.free": "Gratis",
    "price.negotiable": "A convenir",
    "empty.firstIn": "Sé el primero en publicar en {zone}",
    "empty.firstInSub": "Todavía no hay anuncios aquí. Publicar es gratis y sin comisiones.",
    "empty.noResults": "No hay resultados con estos filtros",
    "empty.noResultsSub": "Prueba a quitar algún filtro o a buscar en toda la isla.",
    "empty.publish": "Publicar anuncio",
    "detail.description": "Descripción",
    "detail.contact": "Contactar",
    "detail.edit": "Editar anuncio",
    "detail.memberSince": "Miembro desde {date}",
    "detail.published": "Publicado {date}",
    "detail.messagingSoon": "Mensajería disponible pronto",
    "detail.unavailable": "Este anuncio no está disponible",
    "detail.unavailableSub": "Puede que el anunciante lo haya pausado o eliminado.",
    "detail.adultOnly": "Contenido solo para mayores de 18 años",
    "detail.notFound": "Anuncio no encontrado",
    "detail.back": "Volver",
    "detail.pausedOwner": "Tu anuncio está pausado: nadie más puede verlo.",
    "detail.goMercat": "Ir al Mercat",
    "profile.title": "Mi Perfil",
    "profile.defaultZone": "Mi zona por defecto:",
    "profile.publish": "Publicar anuncio",
    "profile.myData": "Mis datos",
    "profile.myListings": "Mis anuncios",
    "profile.favorites": "Favoritos",
    "profile.messages": "Mensajes",
    "profile.settings": "Ajustes",
    "profile.note1": "Navega sin registrarte por toda la isla. Publica o contacta solo cuando tengas cuenta. Contactos requiere ser ",
    "profile.note2": "mayor de 18 años",
    "profile.logout": "Cerrar sesión",
    "profile.visitor": "Hola, visitante",
    "profile.visitorSub": "Entra para publicar, guardar favoritos y contactar.",
    "profile.soon": "Próximamente",
    "auth.login": "Iniciar sesión",
    "auth.register": "Crear cuenta",
    "auth.google": "Continuar con Google",
    "auth.or": "o",
    "auth.name": "Nombre",
    "auth.email": "Email",
    "auth.password": "Contraseña",
    "auth.birthDate": "Fecha de nacimiento",
    "auth.noAccount": "¿No tienes cuenta?",
    "auth.haveAccount": "¿Ya tienes cuenta?",
    "auth.welcome": "Bienvenido de nuevo",
    "auth.join": "Únete al Mercat",
    "auth.joinSub": "Gratis, local y sin comisiones.",
    "auth.passwordHint": "Mínimo 6 caracteres",
    "auth.required": "Inicia sesión para continuar",
    "auth.requiredSub": "Necesitas una cuenta para publicar, guardar favoritos o contactar. Es gratis.",
    "auth.signingIn": "Iniciando sesión...",
    "birth.title": "¿Cuál es tu fecha de nacimiento?",
    "birth.sub": "La usamos solo para verificar la edad. Sin ella, la categoría Contactos (+18) estará bloqueada.",
    "birth.save": "Guardar",
    "birth.skip": "Ahora no",
    "zoneDialog.title": "Elige tu zona",
    "zoneDialog.sub": "Los anuncios se filtrarán por esta zona por defecto.",
    "publish.title": "Publicar anuncio",
    "publish.editTitle": "Editar anuncio",
    "publish.category": "Categoría",
    "publish.chooseCategory": "Elige una categoría",
    "publish.titleLabel": "Título",
    "publish.titlePh": "Ej: Bicicleta de paseo en buen estado",
    "publish.description": "Descripción",
    "publish.descriptionPh": "Cuenta los detalles: estado, medidas, horarios, cómo recogerlo...",
    "publish.photos": "Fotos",
    "publish.photosHint": "De 1 a 8 fotos · JPG, PNG o WEBP · máx. 10 MB. La primera será la portada.",
    "publish.addPhoto": "Añadir",
    "publish.cover": "Portada",
    "publish.price": "Precio (€)",
    "publish.pricePh": "Vacío = A convenir · 0 = Gratis",
    "publish.zone": "Zona",
    "publish.chooseZone": "Elige un municipio",
    "publish.submit": "Publicar",
    "publish.save": "Guardar cambios",
    "publish.published": "¡Anuncio publicado!",
    "publish.saved": "Cambios guardados",
    "publish.uploading": "Subiendo...",
    "err.required": "Campo obligatorio",
    "err.photosMin": "Añade al menos 1 foto",
    "err.photosMax": "Máximo 8 fotos",
    "err.fileType": "Formato no permitido (solo JPG, PNG o WEBP)",
    "err.fileSize": "La imagen supera los 10 MB",
    "err.upload": "No se pudo subir la imagen",
    "err.generic": "Algo ha ido mal. Inténtalo de nuevo.",
    "err.invalidCredentials": "Email o contraseña incorrectos",
    "err.emailTaken": "Este email ya está registrado",
    "err.tooMany": "Demasiados intentos. Espera 15 minutos.",
    "err.birthInvalid": "Fecha de nacimiento no válida",
    "err.adultOnly": "Esta categoría requiere ser mayor de 18 años",
    "mine.title": "Mis anuncios",
    "mine.active": "Activo",
    "mine.paused": "Pausado",
    "mine.edit": "Editar",
    "mine.pause": "Pausar",
    "mine.reactivate": "Reactivar",
    "mine.delete": "Eliminar",
    "mine.deleteTitle": "¿Eliminar este anuncio?",
    "mine.deleteSub": "Esta acción no se puede deshacer.",
    "mine.cancel": "Cancelar",
    "mine.confirmDelete": "Sí, eliminar",
    "mine.deleted": "Anuncio eliminado",
    "mine.pausedToast": "Anuncio pausado: ya no es visible",
    "mine.reactivatedToast": "Anuncio reactivado",
    "mine.empty": "Aún no has publicado nada",
    "mine.emptySub": "Tu primer anuncio está a un minuto. Gratis y sin comisiones.",
    "fav.title": "Favoritos",
    "fav.empty": "Aún no tienes favoritos",
    "fav.emptySub": "Toca el corazón de cualquier anuncio para guardarlo aquí.",
    "fav.added": "Guardado en favoritos",
    "fav.removed": "Eliminado de favoritos",
    "data.title": "Mis datos",
    "data.changeAvatar": "Cambiar foto",
    "data.save": "Guardar",
    "data.saved": "Datos guardados",
    "data.birthMissing": "Añade tu fecha de nacimiento para acceder a Contactos (+18).",
    "data.birthLocked": "La fecha de nacimiento no se puede modificar.",
    "settings.title": "Ajustes",
    "settings.language": "Idioma",
    "settings.notifications": "Notificaciones",
    "settings.privacy": "Privacidad",
    "messages.title": "Mensajes",
    "messages.soon": "La mensajería llega muy pronto",
    "messages.soonSub": "Podrás hablar con otros vecinos directamente desde la web, sin compartir tu teléfono.",
    "gate.title": "Sección solo para mayores de 18 años",
    "gate.sub": "Para entrar en Contactos confirma tu fecha de nacimiento.",
    "gate.confirm": "Confirmo que soy mayor de 18 años",
    "gate.enter": "Entrar",
    "gate.back": "Volver",
    "gate.loginSub": "Inicia sesión para continuar. Contactos es una sección solo para mayores de edad.",
    "gate.minorTitle": "Esta sección no está disponible para ti",
    "gate.minorSub": "Contactos está reservada a mayores de 18 años. ¡Sigue disfrutando del resto del Mercat!",
    "gate.needConfirm": "Marca la casilla para continuar",
    "gate.verify": "Verificar edad",
    "contact.send": "Enviar mensaje",
    "contact.about": "Sobre mí",
    "contact.lookingFor": "Busca: {v}",
    "contact.languages": "Idiomas: {v}",
    "report.link": "Denunciar anuncio",
    "report.title": "¿Denunciar este anuncio?",
    "report.sub": "Revisaremos el anuncio. Cuéntanos el motivo (opcional).",
    "report.reasonPh": "Motivo...",
    "report.send": "Enviar denuncia",
    "report.done": "Gracias. Hemos recibido tu denuncia.",
    "prop.rooms": "{n} hab.",
    "prop.baths": "{n} baños",
    "prop.area": "{n} m²",
    "prop.features": "Características",
    "prop.location": "Ubicación",
    "prop.openMap": "Ver mapa más grande",
    "unit.mes": "/mes",
    "unit.noche": "/noche",
    "unit.semana": "/semana",
    "form.name": "Nombre",
    "form.age": "Edad (opcional)",
    "form.gender": "Género",
    "form.lookingFor": "Busca",
    "form.languages": "Idiomas",
    "form.about": "Sobre mí",
    "form.aboutPh": "Cuéntanos algo de ti: aficiones, qué te gusta de {region}...",
    "form.titlePreview": "Título del anuncio",
    "form.operation": "Operación",
    "form.priceUnit": "Unidad de precio",
    "form.rooms": "Habitaciones",
    "form.baths": "Baños",
    "form.area": "Superficie (m²)",
    "form.features": "Características",
    "form.contract": "Tipo de contrato",
    "form.schedule": "Jornada",
    "form.salary": "Salario",
    "form.salaryPh": "Ej: 1.600 € brutos/mes",
    "form.year": "Año",
    "form.km": "Kilómetros",
    "form.fuel": "Combustible",
    "form.details": "Detalles",
    "err.ageMin": "La edad debe ser 18 o más",
    "job.salary": "Salario: {v}",
    "motor.year": "Año {v}",
    "motor.km": "{v} km",
    "opt.gender.mujer": "Mujer",
    "opt.gender.hombre": "Hombre",
    "opt.gender.no_binario": "No binario",
    "opt.gender.otro": "Otro",
    "opt.looking_for.amistad": "Amistad",
    "opt.looking_for.relacion": "Relación",
    "opt.looking_for.rollos": "Rollos",
    "opt.looking_for.sexo": "Sexo",
    "contact.audio": "Enviar audio",
    "contact.all": "Todos",
    "form.consent": "Confirmo que mis fotos no contienen desnudos ni contenido explícito y que soy mayor de 18 años",
    "err.consent": "Debes aceptar esta confirmación",
    "err.lookingFor": "Elige al menos una opción",
    "opt.languages.otro": "Otros",
    "opt.operation.alquiler": "Alquiler",
    "opt.operation.venta": "Venta",
    "opt.operation.vacacional": "Alquiler vacacional",
    "opt.price_unit.mes": "€ /mes",
    "opt.price_unit.noche": "€ /noche",
    "opt.price_unit.semana": "€ /semana",
    "opt.price_unit.total": "€ total",
    "opt.features.amueblada": "Amueblada",
    "opt.features.aire_acondicionado": "Aire acondicionado",
    "opt.features.terraza": "Terraza",
    "opt.features.parking": "Parking",
    "opt.features.piscina": "Piscina",
    "opt.features.jardin": "Jardín",
    "opt.features.vistas_mar": "Vistas al mar",
    "opt.features.mascotas": "Admite mascotas",
    "opt.contract.indefinido": "Indefinido",
    "opt.contract.temporal": "Temporal",
    "opt.contract.autonomo": "Autónomo",
    "opt.contract.practicas": "Prácticas",
    "opt.contract.otro": "Otro",
    "opt.schedule.completa": "Jornada completa",
    "opt.schedule.parcial": "Media jornada",
    "opt.schedule.por_horas": "Por horas",
    "opt.schedule.flexible": "Flexible",
    "opt.fuel.gasolina": "Gasolina",
    "opt.fuel.diesel": "Diésel",
    "opt.fuel.electrico": "Eléctrico",
    "opt.fuel.hibrido": "Híbrido",
    "opt.fuel.otro": "Otro",
    "common.loading": "Cargando...",
    "common.close": "Cerrar",
  },
  en: {
    "brand.tagline": "Find accommodation, meet people, discover places, services, jobs and much more.",
    "brand.tagline2": "Always free and commission-free.",
    "zone.all": "Whole island",
    "zone.allRegion": "All of {region}",
    "seo.title": "Mercat Menorca",
    "search.placeholder": "Search {region}...",
    "search.submit": "Search",
    "home.categories": "Categories",
    "home.footer": "Made in {region}, for {region}. No commissions.",
    "home.swipeHint": "Swipe to open the Mercat",
    "nav.home": "Home",
    "nav.mercat": "Mercat",
    "nav.profile": "Profile",
    "nav.prev": "Previous screen",
    "nav.next": "Next screen",
    "mercat.title": "Mercat",
    "mercat.results": "{n} listings",
    "mercat.result1": "1 listing",
    "mercat.price": "Price",
    "mercat.loadMore": "Load more",
    "mercat.end": "You've reached the end",
    "mercat.filters": "Filters",
    "sort.newest": "Newest",
    "sort.price_asc": "Price: low to high",
    "sort.price_desc": "Price: high to low",
    "filters.keyword": "Keyword",
    "filters.keywordPh": "E.g. bike, flat, kayak...",
    "filters.category": "Category",
    "filters.allCategories": "All categories",
    "filters.zone": "Zone",
    "filters.priceMin": "Min price (€)",
    "filters.priceMax": "Max price (€)",
    "filters.sort": "Sort by",
    "filters.clear": "Clear",
    "filters.apply": "Show results",
    "card.details": "See details",
    "price.free": "Free",
    "price.negotiable": "Negotiable",
    "empty.firstIn": "Be the first to post in {zone}",
    "empty.firstInSub": "There are no listings here yet. Posting is free with no commissions.",
    "empty.noResults": "No results with these filters",
    "empty.noResultsSub": "Try removing a filter or searching the whole island.",
    "empty.publish": "Post a listing",
    "detail.description": "Description",
    "detail.contact": "Contact",
    "detail.edit": "Edit listing",
    "detail.memberSince": "Member since {date}",
    "detail.published": "Posted {date}",
    "detail.messagingSoon": "Messaging available soon",
    "detail.unavailable": "This listing is not available",
    "detail.unavailableSub": "The advertiser may have paused or removed it.",
    "detail.adultOnly": "Content for adults (18+) only",
    "detail.notFound": "Listing not found",
    "detail.back": "Back",
    "detail.pausedOwner": "Your listing is paused: nobody else can see it.",
    "detail.goMercat": "Go to the Mercat",
    "profile.title": "My Profile",
    "profile.defaultZone": "My default zone:",
    "profile.publish": "Post a listing",
    "profile.myData": "My details",
    "profile.myListings": "My listings",
    "profile.favorites": "Favourites",
    "profile.messages": "Messages",
    "profile.settings": "Settings",
    "profile.note1": "Browse the whole island without signing up. Post or contact only when you have an account. Contacts requires being ",
    "profile.note2": "18 or older",
    "profile.logout": "Log out",
    "profile.visitor": "Hi, visitor",
    "profile.visitorSub": "Sign in to post, save favourites and contact advertisers.",
    "profile.soon": "Coming soon",
    "auth.login": "Log in",
    "auth.register": "Create account",
    "auth.google": "Continue with Google",
    "auth.or": "or",
    "auth.name": "Name",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.birthDate": "Date of birth",
    "auth.noAccount": "No account yet?",
    "auth.haveAccount": "Already have an account?",
    "auth.welcome": "Welcome back",
    "auth.join": "Join the Mercat",
    "auth.joinSub": "Free, local and commission-free.",
    "auth.passwordHint": "At least 6 characters",
    "auth.required": "Log in to continue",
    "auth.requiredSub": "You need an account to post, save favourites or contact. It's free.",
    "auth.signingIn": "Signing in...",
    "birth.title": "What's your date of birth?",
    "birth.sub": "We only use it to verify your age. Without it, the Contacts (18+) category stays locked.",
    "birth.save": "Save",
    "birth.skip": "Not now",
    "zoneDialog.title": "Choose your zone",
    "zoneDialog.sub": "Listings will be filtered by this zone by default.",
    "publish.title": "Post a listing",
    "publish.editTitle": "Edit listing",
    "publish.category": "Category",
    "publish.chooseCategory": "Choose a category",
    "publish.titleLabel": "Title",
    "publish.titlePh": "E.g. City bike in good condition",
    "publish.description": "Description",
    "publish.descriptionPh": "Share the details: condition, size, schedule, pick-up...",
    "publish.photos": "Photos",
    "publish.photosHint": "1 to 8 photos · JPG, PNG or WEBP · max 10 MB. The first one is the cover.",
    "publish.addPhoto": "Add",
    "publish.cover": "Cover",
    "publish.price": "Price (€)",
    "publish.pricePh": "Empty = Negotiable · 0 = Free",
    "publish.zone": "Zone",
    "publish.chooseZone": "Choose a town",
    "publish.submit": "Publish",
    "publish.save": "Save changes",
    "publish.published": "Listing published!",
    "publish.saved": "Changes saved",
    "publish.uploading": "Uploading...",
    "err.required": "Required field",
    "err.photosMin": "Add at least 1 photo",
    "err.photosMax": "Maximum 8 photos",
    "err.fileType": "Format not allowed (JPG, PNG or WEBP only)",
    "err.fileSize": "Image exceeds 10 MB",
    "err.upload": "Could not upload the image",
    "err.generic": "Something went wrong. Please try again.",
    "err.invalidCredentials": "Wrong email or password",
    "err.emailTaken": "This email is already registered",
    "err.tooMany": "Too many attempts. Wait 15 minutes.",
    "err.birthInvalid": "Invalid date of birth",
    "err.adultOnly": "This category requires being 18 or older",
    "mine.title": "My listings",
    "mine.active": "Active",
    "mine.paused": "Paused",
    "mine.edit": "Edit",
    "mine.pause": "Pause",
    "mine.reactivate": "Reactivate",
    "mine.delete": "Delete",
    "mine.deleteTitle": "Delete this listing?",
    "mine.deleteSub": "This action cannot be undone.",
    "mine.cancel": "Cancel",
    "mine.confirmDelete": "Yes, delete",
    "mine.deleted": "Listing deleted",
    "mine.pausedToast": "Listing paused: no longer visible",
    "mine.reactivatedToast": "Listing reactivated",
    "mine.empty": "You haven't posted anything yet",
    "mine.emptySub": "Your first listing is one minute away. Free and commission-free.",
    "fav.title": "Favourites",
    "fav.empty": "No favourites yet",
    "fav.emptySub": "Tap the heart on any listing to save it here.",
    "fav.added": "Saved to favourites",
    "fav.removed": "Removed from favourites",
    "data.title": "My details",
    "data.changeAvatar": "Change photo",
    "data.save": "Save",
    "data.saved": "Details saved",
    "data.birthMissing": "Add your date of birth to access Contacts (18+).",
    "data.birthLocked": "The date of birth cannot be changed.",
    "settings.title": "Settings",
    "settings.language": "Language",
    "settings.notifications": "Notifications",
    "settings.privacy": "Privacy",
    "messages.title": "Messages",
    "messages.soon": "Messaging is coming very soon",
    "messages.soonSub": "You'll be able to chat with neighbours right on the website, without sharing your phone number.",
    "gate.title": "This section is for adults (18+) only",
    "gate.sub": "To enter Contacts, please confirm your date of birth.",
    "gate.confirm": "I confirm I am 18 or older",
    "gate.enter": "Enter",
    "gate.back": "Go back",
    "gate.loginSub": "Log in to continue. Contacts is an adults-only section.",
    "gate.minorTitle": "This section isn't available to you",
    "gate.minorSub": "Contacts is reserved for people aged 18 or over. Keep enjoying the rest of the Mercat!",
    "gate.needConfirm": "Tick the box to continue",
    "gate.verify": "Verify age",
    "contact.send": "Send message",
    "contact.about": "About me",
    "contact.lookingFor": "Looking for: {v}",
    "contact.languages": "Languages: {v}",
    "report.link": "Report listing",
    "report.title": "Report this listing?",
    "report.sub": "We'll review the listing. Tell us why (optional).",
    "report.reasonPh": "Reason...",
    "report.send": "Send report",
    "report.done": "Thanks. We've received your report.",
    "prop.rooms": "{n} bed.",
    "prop.baths": "{n} baths",
    "prop.area": "{n} m²",
    "prop.features": "Features",
    "prop.location": "Location",
    "prop.openMap": "View larger map",
    "unit.mes": "/month",
    "unit.noche": "/night",
    "unit.semana": "/week",
    "form.name": "Name",
    "form.age": "Age (optional)",
    "form.gender": "Gender",
    "form.lookingFor": "Looking for",
    "form.languages": "Languages",
    "form.about": "About me",
    "form.aboutPh": "Tell us about yourself: hobbies, what you love about {region}...",
    "form.titlePreview": "Listing title",
    "form.operation": "Operation",
    "form.priceUnit": "Price unit",
    "form.rooms": "Bedrooms",
    "form.baths": "Bathrooms",
    "form.area": "Area (m²)",
    "form.features": "Features",
    "form.contract": "Contract type",
    "form.schedule": "Schedule",
    "form.salary": "Salary",
    "form.salaryPh": "E.g. €1,600 gross/month",
    "form.year": "Year",
    "form.km": "Mileage (km)",
    "form.fuel": "Fuel",
    "form.details": "Details",
    "err.ageMin": "Age must be 18 or more",
    "job.salary": "Salary: {v}",
    "motor.year": "Year {v}",
    "motor.km": "{v} km",
    "opt.gender.mujer": "Woman",
    "opt.gender.hombre": "Man",
    "opt.gender.no_binario": "Non-binary",
    "opt.gender.otro": "Other",
    "opt.looking_for.amistad": "Friendship",
    "opt.looking_for.relacion": "Relationship",
    "opt.looking_for.rollos": "Casual",
    "opt.looking_for.sexo": "Sex",
    "contact.audio": "Send audio",
    "contact.all": "All",
    "form.consent": "I confirm my photos contain no nudity or explicit content and that I am 18 or older",
    "err.consent": "You must accept this confirmation",
    "err.lookingFor": "Choose at least one option",
    "opt.languages.otro": "Other",
    "opt.operation.alquiler": "Rent",
    "opt.operation.venta": "Sale",
    "opt.operation.vacacional": "Holiday rental",
    "opt.price_unit.mes": "€ /month",
    "opt.price_unit.noche": "€ /night",
    "opt.price_unit.semana": "€ /week",
    "opt.price_unit.total": "€ total",
    "opt.features.amueblada": "Furnished",
    "opt.features.aire_acondicionado": "Air conditioning",
    "opt.features.terraza": "Terrace",
    "opt.features.parking": "Parking",
    "opt.features.piscina": "Pool",
    "opt.features.jardin": "Garden",
    "opt.features.vistas_mar": "Sea views",
    "opt.features.mascotas": "Pets allowed",
    "opt.contract.indefinido": "Permanent",
    "opt.contract.temporal": "Temporary",
    "opt.contract.autonomo": "Freelance",
    "opt.contract.practicas": "Internship",
    "opt.contract.otro": "Other",
    "opt.schedule.completa": "Full-time",
    "opt.schedule.parcial": "Part-time",
    "opt.schedule.por_horas": "Hourly",
    "opt.schedule.flexible": "Flexible",
    "opt.fuel.gasolina": "Petrol",
    "opt.fuel.diesel": "Diesel",
    "opt.fuel.electrico": "Electric",
    "opt.fuel.hibrido": "Hybrid",
    "opt.fuel.otro": "Other",
    "common.loading": "Loading...",
    "common.close": "Close",
  },
};
Object.entries(CHAT_DICT).forEach(([l, d]) => Object.assign(DICT[l], d));

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const { region } = useRegion();
  const [lang, setLangState] = useState(() => {
    const saved = localStorage.getItem("mm_lang");
    return region.languages.includes(saved) && DICT[saved] ? saved : region.default_language;
  });
  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);
  const setLang = useCallback((l) => {
    localStorage.setItem("mm_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback(
    (key, vars) => {
      let s = DICT[lang]?.[key] ?? DICT[region.default_language]?.[key] ?? DICT.es[key] ?? key;
      Object.entries({ region: region.name, ...vars }).forEach(([k, v]) => (s = s.split(`{${k}}`).join(v)));
      return s;
    },
    [lang, region]
  );
  return <LangContext.Provider value={{ lang, setLang, t, languages: region.languages.filter((l) => DICT[l]) }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
